export default {
  props: ['onboarding_checklist'],
  template: '#onboarding_checklist_template',
  data () {
    return {
      steps: [{
        icon: this.onboarding_checklist.browse_courses_visited ? 'kf-checkmark' : 'kf-coursework',
        title: 'Find Courses',
        subtitle: 'Learn something new today.',
        btn_link: Kadenze.Routes.courses_path(),
        btn_text: 'Find Courses'
      },
      {
        icon: this.onboarding_checklist.portfolio_project_created ? 'kf-checkmark' : 'kf-portfolio',
        title: 'Create Portfolio',
        subtitle: 'Share your work with the world.',
        btn_link: this.onboarding_checklist.new_porfolio_project_path,
        btn_text: 'Create Portfolio'
      },
      {
        icon: this.onboarding_checklist.gallery_visited ? 'kf-checkmark' : 'kf-gallery',
        title: 'Browse Gallery',
        subtitle: 'Be inspired by other learners.',
        btn_link: Kadenze.Routes.course_gallery_overview_path('all'),
        btn_text: 'Browse Gallery'
      },
      {
        icon: this.onboarding_checklist.referal_visited ? 'kf-checkmark' : 'kf-referral',
        title: 'Refer a Friend',
        subtitle: 'Get free Premium Membership.',
        btn_link: this.onboarding_checklist.referral_path,
        btn_text: 'Refer a Friend'
      }
      ]
    };
  }
};
